import config from "../config";
import {bindParams, categoryItemMediator} from "../utils/api";
import * as api from './api';
import * as actions from './categoryMatching';

const CONFIG = config();

export const getTrees = (matching_catalog_name) => {
	return dispatch => {
		dispatch(api.requestStart());
		return fetch(bindParams(CONFIG.URL_CATEGORY_MATCHING_GET_TREES, {matching_catalog_name}))
			.then(result => result.json())
			.then(result => {
				dispatch(api.requestStart());
				dispatch(actions.treesLoaded({
					end_categories: result.response.end_categories.map(categoryItemMediator),
					matching_categories: result.response.matching_categories.map(categoryItemMediator),
				}));
			});
	}
};

export const categoryMatchingCreate = (category_matching_key, end_category_key, catalog_name) => {
	return dispatch => {
		dispatch(api.requestStart());
		return fetch(bindParams(CONFIG.URL_CATEGORY_MATCHING_CREATE, {category_matching_key, end_category_key, catalog_name}))
			.then(result => result.json())
			.then(result => {
				dispatch(api.requestStart());
				dispatch(actions.matchingCategory(categoryItemMediator(result.response)));
			});
	}
};


export const categoryMatchRemove = (id) => {
		return dispatch => {
			dispatch(api.requestStart());
			return fetch(bindParams(CONFIG.URL_CATEGORY_MATCHING_DELETE, {id}), {method: 'POST'})
				.then(result => result.json())
				.then(result => {
					dispatch(api.requestEnd());
					dispatch(actions.matchingCategoryDelete(categoryItemMediator(result.response)));
				});
		}
};



// WEBPACK FOOTER //
// ./frontend/actions/apiCategoryMaching.js